import { Component, type ReactNode } from "react";

type Props = { children: ReactNode };
type State = { error: Error | null };

export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error) {
    // eslint-disable-next-line no-console
    console.error("[CasinoMenu] error boundary caught:", error);
  }

  render() {
    if (this.state.error) {
      return (
        <div className="grid min-h-screen place-items-center bg-ink-50 p-6 text-center">
          <div className="card max-w-md p-8">
            <h1 className="text-2xl font-bold">Något gick fel</h1>
            <p className="mt-2 text-sm text-ink-600">
              {this.state.error.message ||
                "Vi kunde inte rendera sidan. Försök ladda om webbplatsen."}
            </p>
            <button
              type="button"
              onClick={() => location.reload()}
              className="btn-primary mt-4"
            >
              Ladda om
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
